import React, { useEffect, useState } from "react";
import AuthenticatedLayout from "../Layouts/AuthenticatedLayout";
import api from "../axios"; // Axios instance
import { useAuth } from "../context/AuthContext";
import Modal from "../Components/Modal"; // Using your provided Modal component

import { Cross2Icon, EyeOpenIcon, CheckIcon } from "@radix-ui/react-icons";

export default function Dashboard() {
  const [contacts, setContacts] = useState([]);
  const [blendRequests, setBlendRequests] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState(null);
  const { user } = useAuth();

  const fetchContacts = async () => {
    try {
      const response = await api.get("/api/get-all-contacts");
      setContacts(response.data);
    } catch (error) {
      console.error("Σφάλμα κατά τη λήψη επαφών", error);
      setError("Αποτυχία λήψης επαφών");
    }
  };

  const fetchBlendRequests = async () => {
    try {
      const response = await api.get("/api/get-requests-blend");
      setBlendRequests(response.data);
    } catch (error) {
      console.error("Σφάλμα κατά τη λήψη αιτήσεων blend", error);
      setError("Αποτυχία λήψης αιτήσεων blend");
    }
  };

  const markAsRead = async (id) => {
    try {
      await api.post(`/api/mark-as-read/${id}`);
      alert("Το email μαρκάρεται ως διαβασμένο");
    } catch (error) {
      console.error("Σφάλμα κατά τη μαρκαριστική πράξη", error);
      alert("Αποτυχία μαρκαρίσματος email ως διαβασμένο");
    }
  };

  useEffect(() => {
    document.title = "Πίνακας Ελέγχου - Coffee Roast City";
    fetchContacts();
    fetchBlendRequests();
  }, []);

  const handleOpenModal = (data, type) => {
    setModalData({ title: type, data });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenDetailModal = (data) => {
    setDetailModalData(data);
    setIsDetailModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
  };

  return (
    <AuthenticatedLayout user={user}>
      <div className="container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold mb-6">Πίνακας Ελέγχου</h1>

        {/* Reports Section */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {/* Contacts Box */}
          <div
            className="bg-blue-500 text-white flex flex-col items-center justify-center p-4 rounded-lg shadow-lg hover:bg-blue-600 cursor-pointer aspect-square w-28 sm:w-36 lg:w-40"
            onClick={() => handleOpenModal(contacts, "Επικοινωνία")}
          >
            <h2 className="text-sm font-semibold">Επικοινωνία</h2>
            <p className="text-2xl font-bold">{contacts.length}</p>
          </div>

          {/* Blend Requests Box */}
          <div
            className="bg-green-500 text-white flex flex-col items-center justify-center p-4 rounded-lg shadow-lg hover:bg-green-600 cursor-pointer aspect-square w-28 sm:w-36 lg:w-40"
            onClick={() => handleOpenModal(blendRequests, "Αιτήσεις Blend")}
          >
            <h2 className="text-sm font-semibold">Αιτήσεις Blend</h2>
            <p className="text-2xl font-bold">{blendRequests.length}</p>
          </div>
        </div>

        {/* Modal for Details */}
        <Modal show={isModalOpen} onClose={handleCloseModal} maxWidth="full">
          <div className="relative p-4">
            {/* Close Button */}
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            >
              <Cross2Icon className="w-6 h-6" />
            </button>
            <h2 className="text-xl font-bold mb-4">{modalData?.title} Λεπτομέρειες</h2>
            {error ? (
              <div className="text-red-500">{error}</div>
            ) : modalData?.data?.length > 0 ? (
              <table className="w-full table-auto border-collapse bg-white rounded shadow">
                <thead>
                  <tr className="bg-gray-200">
                    {modalData.title === "Επαφές" ? (
                      <>
                        <th className="border px-2 py-2 text-left">Όνομα</th>
                        <th className="border px-2 py-2 text-left">Πόλη</th>
                        <th className="border px-2 py-2 text-left">Τηλέφωνο</th>
                        <th className="border px-2 py-2 text-left">Email</th>
                        <th className="border px-2 py-2 text-left">Μήνυμα</th>
                      </>
                    ) : (
                      <>
                        <th className="border px-2 py-2 text-left">Όνομα</th>
                        <th className="border px-2 py-2 text-left">Email</th>
                        <th className="border px-2 py-2 text-left">Λεπτομέρειες</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {modalData.data.map((item, index) => {
                    let blendData;
                    try {
                      blendData = item.blend_data ? JSON.parse(item.blend_data) : null;
                    } catch {
                      blendData = null;
                    }

                    return (
                      <tr key={index} className="border-t">
                        {/* Row Data for Contacts */}
                        {modalData.title === "Επαφές" ? (
                          <>
                            <td className="border px-2 py-2 text-left">{item.name || "N/A"}</td>
                            <td className="border px-2 py-2 text-left">{item.city || "N/A"}</td>
                            <td className="border px-2 py-2 text-left">{item.telephone || "N/A"}</td>
                            <td className="border px-2 py-2 text-left">{item.email || "N/A"}</td>
                            <td className="border px-2 py-2 text-center">
                              {item.message ? (
                                <button
                                  onClick={() => handleOpenDetailModal(item.message)}
                                  className="text-blue-500 hover:text-blue-700"
                                >
                                  <EyeOpenIcon className="w-5 h-5" />
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="border px-2 py-2 text-left">{item.name || "N/A"}</td>
                            <td className="border px-2 py-2 text-left">{item.email || "N/A"}</td>
                            <td className="border px-2 py-2 text-left">
                              <button
                                onClick={() =>
                                  handleOpenDetailModal({
                                    blendData,
                                    userData: item
                                  })
                                }
                                className="text-blue-500 hover:text-blue-700"
                              >
                                <EyeOpenIcon className="w-5 h-5" />
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p>Δεν υπάρχουν διαθέσιμα δεδομένα.</p>
            )}
          </div>
        </Modal>

        {/* Detail Modal */}
        <Modal show={isDetailModalOpen} onClose={handleCloseDetailModal} maxWidth="3xl">
          <div className="relative">
            {/* Fixed Header with Close Button */}
            <div className="sticky top-0 bg-white p-6 border-b z-10">
              <button
                onClick={handleCloseDetailModal}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
              >
                <Cross2Icon className="w-6 h-6" />
              </button>
              <h2 className="text-xl font-bold pr-8">Λεπτομέρειες Αίτησης Blend</h2>
            </div>

            {/* Scrollable Content */}
            <div className="p-6 max-h-[calc(100vh-200px)] overflow-y-auto">
              <div className="flex flex-col space-y-6">
                {/* Contact and Blend Info Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Contact Information */}
                  <div className="bg-white p-6 rounded-lg shadow-sm border">
                    <h3 className="text-lg font-semibold mb-4">Στοιχεία Επικοινωνίας</h3>
                    <div className="space-y-3">
                      {[
                        { label: 'Ονοματεπώνυμο', key: 'name' },
                        { label: 'Διεύθυνση', key: 'address' },
                        { label: 'Επωνυμία Επιχείρησης', key: 'company_name' },
                        { label: 'ΑΦΜ', key: 'afm' },
                        { label: 'Email', key: 'email' },
                        { label: 'Τηλέφωνο', key: 'telephone' }
                      ].map(({ label, key }) => (
                        <div key={key} className="flex flex-col">
                          <span className="text-gray-600 text-sm">{label}:</span>
                          <p className="font-medium">
                            {detailModalData?.userData?.[key] || '-'}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Blend Information */}
                  <div className="bg-white p-6 rounded-lg shadow-sm border">
                    <h3 className="text-lg font-semibold mb-4">Στοιχεία Blend</h3>
                    <div className="space-y-3">
                      <div className="flex flex-col">
                        <span className="text-gray-600 text-sm">Τύπος Blend:</span>
                        <p className="font-medium">
                          {detailModalData?.blendData?.roastType || '-'}
                        </p>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-gray-600 text-sm">Επιλεγμένοι Καφέδες:</span>
                        {detailModalData?.blendData?.origin_coffees?.length > 0 ? (
                          <ul className="mt-2 space-y-2">
                            {detailModalData.blendData.origin_coffees.map((coffee, index) => (
                              <li key={index} className="flex justify-between items-center bg-gray-50 p-2 rounded">
                                <span className="font-medium">{coffee.name}</span>
                                <span className="text-gray-600 font-medium">{coffee.percentage}%</span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-gray-500">Δεν υπάρχουν επιλεγμένοι καφέδες</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Message Section */}
                {detailModalData?.userData?.message && (
                  <div className="bg-white p-6 rounded-lg shadow-sm border">
                    <h3 className="text-lg font-semibold mb-4">Μήνυμα</h3>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <p className="text-gray-700 whitespace-pre-wrap">
                        {detailModalData.userData.message}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>

      </div>
    </AuthenticatedLayout>
  );
}
